<template>
	<div class="org_major">
		<filterbar s_name="专业" @searchName="setSearchName" @school_search="setSchool_search"
			@dept_search="setDept_search" :getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray">
		</filterbar>
		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>专业列表({{tableDataCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="dialogEdit = true">添加专业
				</el-button>
			</div>
			<el-table :data="showDate()">
				<el-table-column fixed type="index" width="50" align="center">
					<template slot-scope="scope">
						{{(page_current-1)*page_size+scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column label="学校名称" align="left">
					<template slot-scope="scope">
						{{showSchoolName(scope.row.schoolId)}}
					</template>
				</el-table-column>
				<el-table-column label="学院名称" align="left">
					<template slot-scope="scope">
						{{showDeptName(scope.row.deptId)}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="专业名称" align="left"> </el-table-column>
				<el-table-column prop="firstLetter" label="首字母" align="left"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column fixed="right" label="操作" align="center" width="200">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" style="margin-right: 10px;" size="mini"
							@click="dialogEdit2_data = scope.row; dialogEdit2 = true">编辑</el-button>
						<el-popconfirm confirm-button-text='确认' cancel-button-text='取消' icon="el-icon-info"
							icon-color="red" title="确定删除吗？" @confirm="del(scope.row.id)">
							<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<major-edit type="add" title="添加专业" :dialogVisible="dialogEdit" @before-close="dialogEdit=false;loadData()"
			:getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray" :getMajorArrayName="getMajorArray">
		</major-edit>
		<major-edit type="update" title="编辑专业" :dialogVisible="dialogEdit2" @before-close="dialogEdit2=false;loadData()"
			:obj="dialogEdit2_data" :getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray"
			:getMajorArrayName="getMajorArray"></major-edit>
	</div>
</template>

<script>
	import majorEdit from './major/edit'
	import filterbar from '@/components/org-filterbar/filterBar2.vue'
	export default {
		name: 'dept',
		data() {
			return {
				page_size: 10,
				page_current: 1,
				tableDataCount: 0,
				search_name: '',
				search_school: '',
				search_dept: '',
				dialogEdit: false,
				dialogEdit2: false,
				dialogEdit2_data: null,
				getMajorArray: [],
				getDeptArray: [],
				getSchoolArray: []
			}
		},
		created() {
			this.loadData()
		},
		components: {
			majorEdit,
			filterbar
		},
		methods: {
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showDate() {
				let _data = this.getMajorArray
					.filter(item => item.name &&
						item.name.search(this.search_name) > -1 &&
						item.schoolId.search(this.search_school) > -1 &&
						item.deptId.search(this.search_dept) > -1)
				this.tableDataCount = _data.length
				return _data.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
			},
			showDept() {
				return this.getDeptArray.filter(item => {
					return item.schoolId.search(this.search_school) > -1
				})
			},
			setSearchName(val) {
				this.search_name = val
			},
			setSchool_search(val) {
				this.search_school = val
			},
			setDept_search(val) {
				this.search_dept = val
			},
			showSchoolName(val) {
				let school = this.getSchoolArray.find(item => {
					return item.id == val
				})
				return school.name
			},
			showDeptName(val) {
				let dept = this.getDeptArray.find(item => {
					return item.id == val
				})
				if (dept) {
					return dept.name
				}
				return ''
			},
			del(id) {
				this.$http.get('api/Org/DelMajor/' + id).then(res => {
					this.loadData()
				})
			},
			async loadData() {
				await this.$http.get('api/Org/GetSchools').then(res => {
					this.getSchoolArray = res.data.data
				})
				await this.$http.get('api/org/GetDept/').then(res => {
					this.getDeptArray = []
					res.data.data.map(item => {
						this.getSchoolArray != null && this.getSchoolArray.map(item1 => {
							if (item1.id == item.schoolId) {
								this.getDeptArray.push(item)
							}
						})
					})
				})
				await this.$http.get('api/org/GetMajor/').then(res => {
					this.getMajorArray = []
					res.data.data.map(item => {
						this.getDeptArray.map(item1 => {
							if (item1.id == item.deptId) {
								this.getMajorArray.push(item)
							}
						})
					})


				})
			}
		}

	}
</script>

<style lang="scss">
	.org_major{
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>